import { Icon, MenuItem, TIcons } from 'ui';
import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import MuiMenu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { ListItemIcon } from '@mui/material';

type MenuItemProps = {
  value: number;
  label: string;
  disabled?: boolean;
  icon?: TIcons;
};

type Props = {
  items: MenuItemProps[];
  onItemClick: (value: number) => void;
  layout?: 'row' | 'column';
};

export default function Menu({ items, onItemClick, layout = 'row' }: Props) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        sx={{ backgroundColor: 'secondary.main', '&:hover': { backgroundColor: 'secondary.dark' }, borderRadius: 1 }}
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <MuiMenu anchorEl={anchorEl} open={open} onClose={handleClose} sx={{ display: 'flex', flexDirection: layout }}>
        {items.map(item => (
          <MenuItem
            key={item.value}
            onClick={() => {
              onItemClick(item.value);
            }}
            disabled={item.disabled}
          >
            {item.icon ? (
              <>
                <ListItemIcon>
                  <Icon name={item.icon} />
                </ListItemIcon>
                {item.label}
              </>
            ) : (
              item.label
            )}
          </MenuItem>
        ))}
      </MuiMenu>
    </div>
  );
}
